/**
 * Проверка на то, является ли аргумент объектом
 */
export const isObject = (x: unknown): x is Record<string, unknown> =>
  typeof x === 'object' && !Array.isArray(x) && x !== null
